import { useQuery } from "@tanstack/react-query"

import couponApi from "./couponApi"

const useCouponCodeQuery = () => {
  const { data, isFetching } = useQuery(["couponApi.couponCode"], couponApi.couponCode)

  return { ...data, isFetching }
}

export default useCouponCodeQuery
